import { render, staticRenderFns } from "./ManageDriversNewRoute.vue?vue&type=template&id=38b9d153&scoped=true&"
import script from "./ManageDriversNewRoute.vue?vue&type=script&lang=js&"
export * from "./ManageDriversNewRoute.vue?vue&type=script&lang=js&"
import style0 from "./ManageDriversNewRoute.vue?vue&type=style&index=0&id=38b9d153&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9d153",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VContainer})
